// extracted by mini-css-extract-plugin
export var dropdownIcon = "_p2-6";
export var imgContainer = "_p2-3";
export var menuIcon = "_p2-5";
export var pillWrapper = "_p2-2";
export var pillsContainer = "_p2-1";
export var subscriptionCard = "_p2-0";
export var subscriptionLogo = "_p2-4";